export const INCREASE_IRONTHRONE = 'INCREASE_IRONTHRONE';
export const DECREASE_IRONTHRONE = 'DECREASE_IRONTHRONE';
export const MOVE_IRONTHRONE = 'MOVE_IRONTHRONE';
export const INCREASE_FIEFDOMS = 'INCREASE_FIEFDOMS';
export const DECREASE_FIEFDOMS = 'DECREASE_FIEFDOMS';
export const MOVE_FIEFDOMS = 'MOVE_FIEFDOMS';
export const INCREASE_KINGSCOURT = 'INCREASE_KINGSCOURT';
export const DECREASE_KINGSCOURT = 'DECREASE_KINGSCOURT';
export const MOVE_KINGSCOURT = 'MOVE_KINGSCOURT';

